import { useState as n, useRef as e, useCallback as t, useEffect as o, useLayoutEffect as r } from "react";
import { flushSync as i } from "react-dom";
import l from "tiny-warning";
function a() {
  return a = Object.assign || function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var o in t) Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
    }
    return n;
  }, a.apply(this, arguments);
}
function u(n, e) {
  if (null == n) return {};
  var t,
    o,
    r = {},
    i = Object.keys(n);
  for (o = 0; o < i.length; o++) e.indexOf(t = i[o]) >= 0 || (r[t] = n[t]);
  return r;
}
var c = function c() {};
function d(n) {
  return null != n && n.current ? n.current.scrollHeight : (l(!0, "useCollapse was not able to find a ref to the collapse element via `getCollapseProps`. Ensure that the element exposes its `ref` prop. If it exposes the ref prop under a different name (like `innerRef`), use the `refKey` property to change it. Example:\n\n{...getCollapseProps({refKey: 'innerRef'})}"), "auto");
}
var s = function s() {
  var n = arguments;
  return function () {
    var e = arguments;
    return [].slice.call(n).forEach(function (n) {
      return n && n.apply(void 0, [].slice.call(e));
    });
  };
};
function f(n, e) {
  if (null != n) if ("function" == typeof n) n(e);else try {
    n.current = e;
  } catch (t) {
    throw new Error('Cannot assign value "' + e + '" to ref "' + n + '"');
  }
}
var p = "undefined" != typeof window ? r : o,
  h = !1,
  v = 0,
  g = function g() {
    return ++v;
  },
  m = ["duration", "easing", "collapseStyles", "expandStyles", "onExpandStart", "onExpandEnd", "onCollapseStart", "onCollapseEnd", "isExpanded", "defaultExpanded", "hasDisabledAnimation"],
  x = ["disabled", "onClick"],
  y = ["style", "onTransitionEnd", "refKey"];
function E(r) {
  var v,
    E,
    b = void 0 === r ? {} : r,
    C = b.duration,
    w = b.easing,
    S = void 0 === w ? "cubic-bezier(0.4, 0, 0.2, 1)" : w,
    k = b.collapseStyles,
    A = void 0 === k ? {} : k,
    O = b.expandStyles,
    P = void 0 === O ? {} : O,
    T = b.onExpandStart,
    q = void 0 === T ? c : T,
    D = b.onExpandEnd,
    F = void 0 === D ? c : D,
    K = b.onCollapseStart,
    j = void 0 === K ? c : K,
    N = b.onCollapseEnd,
    z = void 0 === N ? c : N,
    H = b.isExpanded,
    I = b.defaultExpanded,
    M = void 0 !== I && I,
    R = b.hasDisabledAnimation,
    B = void 0 !== R && R,
    V = u(b, m),
    _ = function (r, i) {
      var a = n(i || !1),
        u = a[0],
        c = a[1],
        d = e(null != r),
        s = d.current ? r : u,
        f = t(function (n) {
          d.current || c(n);
        }, []);
      return o(function () {
        l(!(d.current && null == r), "useCollapse is changing from controlled to uncontrolled. useCollapse should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled collapse for the lifetime of the component. Check the `isExpanded` prop."), l(!(!d.current && null != r), "useCollapse is changing from uncontrolled to controlled. useCollapse should not switch from uncontrolled to controlled (or vice versa). Decide between using a controlled or uncontrolled collapse for the lifetime of the component. Check the `isExpanded` prop.");
      }, [r]), [s, f];
    }(H, M),
    G = _[0],
    J = _[1],
    L = function (e) {
      var t = h ? g() : null,
        r = n(t),
        i = r[0],
        l = r[1];
      return p(function () {
        null === i && l(g());
      }, []), o(function () {
        !1 === h && (h = !0);
      }, []), null != i ? String(i) : void 0;
    }(),
    Q = e(null);
  v = Q, E = function E(n) {}, "production" !== process.env.NODE_ENV && (E = function E(n) {
    if (null != n && n.current) {
      var e = window.getComputedStyle(n.current),
        t = e.paddingTop,
        o = e.paddingBottom;
      l(!(t && "0px" !== t || o && "0px" !== o), "react-collapsed: Padding applied to the collapse element will cause the animation to break and not perform as expected. To fix, apply equivalent padding to the direct descendent of the collapse element.");
    }
  }), o(function () {
    E(v);
  }, [v]);
  var U,
    W,
    X,
    Y = (V.collapsedHeight || 0) + "px",
    Z = {
      display: "0px" === Y ? "none" : "block",
      height: Y,
      overflow: "hidden"
    },
    $ = n(G ? {} : Z),
    nn = $[0],
    en = $[1],
    tn = function tn(n) {
      i(function () {
        en(n);
      });
    },
    on = function on(n) {
      tn(function (e) {
        return a({}, e, n);
      });
    };
  function rn(n) {
    if (B) return {};
    var e = C || function (n) {
      if (!n || "string" == typeof n) return 0;
      var e = n / 36;
      return Math.round(10 * (4 + 15 * Math.pow(e, .25) + e / 5));
    }(n);
    return {
      transition: "height " + e + "ms " + S
    };
  }
  U = function U() {
    G ? requestAnimationFrame(function () {
      q(), on(a({}, P, {
        willChange: "height",
        display: "block",
        overflow: "hidden"
      })), requestAnimationFrame(function () {
        var n = d(Q);
        on(a({}, rn(n), {
          height: n
        }));
      });
    }) : requestAnimationFrame(function () {
      j();
      var n = d(Q);
      on(a({}, A, rn(n), {
        willChange: "height",
        height: n
      })), requestAnimationFrame(function () {
        on({
          height: Y,
          overflow: "hidden"
        });
      });
    });
  }, W = [G, Y], X = e(!0), o(function () {
    if (!X.current) return U();
    X.current = !1;
  }, W);
  var ln = function ln(n) {
    if (n.target === Q.current && "height" === n.propertyName) if (G) {
      var e = d(Q);
      e === nn.height ? tn({}) : on({
        height: e
      }), F();
    } else nn.height === Y && (tn(Z), z());
  };
  return {
    getToggleProps: function getToggleProps(n) {
      var e = void 0 === n ? {} : n,
        t = e.disabled,
        o = void 0 !== t && t,
        r = e.onClick,
        i = void 0 === r ? c : r,
        l = u(e, x);
      return a({
        type: "button",
        role: "button",
        id: "react-collapsed-toggle-" + L,
        "aria-controls": "react-collapsed-panel-" + L,
        "aria-expanded": G,
        tabIndex: 0,
        disabled: o
      }, l, {
        onClick: o ? c : s(i, function () {
          return J(function (n) {
            return !n;
          });
        })
      });
    },
    getCollapseProps: function getCollapseProps(n) {
      var e,
        t = void 0 === n ? {} : n,
        o = t.style,
        r = void 0 === o ? {} : o,
        i = t.onTransitionEnd,
        l = void 0 === i ? c : i,
        d = t.refKey,
        p = void 0 === d ? "ref" : d,
        h = u(t, y);
      return a({
        id: "react-collapsed-panel-" + L,
        "aria-hidden": !G
      }, h, ((e = {})[p] = function () {
        var n = [].slice.call(arguments);
        return n.every(function (n) {
          return null == n;
        }) ? null : function (e) {
          n.forEach(function (n) {
            f(n, e);
          });
        };
      }(Q, h[p]), e.onTransitionEnd = s(ln, l), e.style = a({
        boxSizing: "border-box"
      }, r, nn), e));
    },
    isExpanded: G,
    setExpanded: J
  };
}
export { E as default };